import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "person-card" }
const _hoisted_2 = { class: "num" }
const _hoisted_3 = { class: "person-card__content" }
const _hoisted_4 = { class: "person-card__name" }
const _hoisted_5 = { class: "person-card__position" }
const _hoisted_6 = { class: "person-card__contact" }
const _hoisted_7 = { class: "person-card__buttons buttons-inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ResizableImage, {
      classes: "person-card__photo",
      url: _ctx.estateAgent.photoRelativeUrl,
      placeholder: "img/no-photo-user.png",
      backgroundImage: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.estateAgent.adCount), 1)
      ]),
      _: 1
    }, 8, ["url"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.estateAgent.fullName), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.estateAgent.roleTitle), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, _toDisplayString(_ctx.estateAgent.email), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.estateAgent.phoneNumber), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: { name: 'AdUserAgencyList', query: { frontUserId: _ctx.estateAgent.frontUserId } },
          tag: "button",
          class: "button button--primary reversed"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentListItem.button-agency-list')), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          class: "button button--primary",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onEdit && _ctx.onEdit(...args)))
        }, _toDisplayString(_ctx.$t('EstateAgentListItem.button-edit')), 1)
      ])
    ])
  ]))
}